import React, { PureComponent, createRef } from 'react';
import { findDOMNode } from 'react-dom';
import PropTypes from 'prop-types';
import { Form } from 'react-final-form';
import cx from 'classnames';

import CrewTypeSelector from './CrewTypeSelector';
import StepPersonalInformation from './StepPersonalInformation';
import StepAbout from './StepAbout';
import StepOccupations from './StepOccupations';
import StepSkills from './StepSkills';
import Button from '../UI/Button';
import Tabs from '../UI/Tabs';
import API from '../../services/API';
import { withTranslation } from '../../i18n';
import styles from './styles.css';

const STEPS = {
  PERSONAL_INFORMATION: 'PERSONAL_INFORMATION',
  ABOUT: 'ABOUT',
  OCCUPATIONS: 'OCCUPATIONS',
  SKILLS: 'SKILLS',
};

class ProfileForm extends PureComponent {
  state = {
    currentStep: this.props.isRegistered ? STEPS.ABOUT : STEPS.PERSONAL_INFORMATION,
    crewType: null,
  };

  ref = createRef();

  setCurrentStep = (event, step) => {
    this.setState({ currentStep: step });
  };

  goToNextStep = () => {
    const nextStep = this.getNextStep();
    this.setState({ currentStep: nextStep });
    this.scrollToTopOfForm();
  };

  goToPreviousStep = () => {
    const nextStep = this.getPreviousStep();
    this.setState({ currentStep: nextStep });
    this.scrollToTopOfForm();
  };

  getNextStep = () => {
    const values = Object.values(STEPS);
    const stepKeys = values;
    const index = values.indexOf(this.state.currentStep);

    if (index === values.length - 1) {
      return values[0];
    }

    return values[index + 1];
  };

  getPreviousStep = () => {
    const values = Object.values(STEPS);
    const stepKeys = values;
    const index = values.indexOf(this.state.currentStep);

    const previousIndex = Math.max(0, index - 1);

    return values[previousIndex];
  };

  scrollToTopOfForm = () => {
    const form = findDOMNode(this.ref.current);
    form && form.scrollIntoView();
  };

  handleSetCrewType = crewType => {
    this.setState({ crewType });
  };

  render() {
    const { currentStep, isSubmitting, crewType } = this.state;
    const { t, user, setUser, serviceProfile, setServiceProfile, mode, status, initialCrewType } = this.props;

    if (!initialCrewType && !crewType && (status === 'open' || typeof status === 'undefined')) {
      return <CrewTypeSelector onChange={this.handleSetCrewType} />;
    }

    return (
      <>
        <Tabs className="mb-5" ref={this.ref} className={styles.tabs}>
          <Tabs.Tab
            active={currentStep === STEPS.PERSONAL_INFORMATION}
            // onClick={event => this.setCurrentStep(event, STEPS.PERSONAL_INFORMATION)}
          >
            {t('steps.personalInformation')}
          </Tabs.Tab>
          <Tabs.Tab
            active={currentStep === STEPS.ABOUT}
            // onClick={event => this.setCurrentStep(event, STEPS.ABOUT)}
          >
            {t('steps.about')}
          </Tabs.Tab>
          <Tabs.Tab
            active={currentStep === STEPS.OCCUPATIONS}
            // onClick={event => this.setCurrentStep(event, STEPS.OCCUPATIONS)}
          >
            {t('steps.occupation')}
          </Tabs.Tab>
          <Tabs.Tab
            active={currentStep === STEPS.SKILLS}
            // onClick={event => this.setCurrentStep(event, STEPS.SKILLS)}
          >
            {t('steps.skills')}
          </Tabs.Tab>
        </Tabs>
        <div>
          <StepPersonalInformation
            visible={currentStep === STEPS.PERSONAL_INFORMATION}
            goToNextStep={this.goToNextStep}
            user={user}
            setUser={setUser}
            mode={mode}
            crewType={crewType || serviceProfile.crewType}
          />
          <StepAbout
            visible={currentStep === STEPS.ABOUT}
            goToPreviousStep={this.goToPreviousStep}
            goToNextStep={this.goToNextStep}
            serviceProfile={serviceProfile}
            setServiceProfile={setServiceProfile}
            crewType={initialCrewType || crewType || serviceProfile.crewType}
          />
          <StepOccupations
            visible={currentStep === STEPS.OCCUPATIONS}
            goToPreviousStep={this.goToPreviousStep}
            goToNextStep={this.goToNextStep}
            serviceProfile={serviceProfile}
            setServiceProfile={setServiceProfile}
          />
          <StepSkills
            visible={currentStep === STEPS.SKILLS}
            goToPreviousStep={this.goToPreviousStep}
            goToNextStep={this.goToNextStep}
            serviceProfile={serviceProfile}
            setServiceProfile={setServiceProfile}
          />
        </div>
      </>
    );
  }
}

ProfileForm.propTypes = {
  user: PropTypes.object.isRequired,
  serviceProfile: PropTypes.object.isRequired,
  mode: PropTypes.oneOf(['register', 'update']),
};

ProfileForm.defaultProps = {
  mode: 'update',
};

export default withTranslation('common')(ProfileForm);
